import {ILink} from '@/setup/router/links';

export interface LinkClass {
    setLinkPermissions(links: ILink[]);

    setLinkPermissionsRecursive(links: ILink, modules: string[]);

    clean(links: ILink[]);

    checkModule(modules: string[], module: string);
}


export class BaseLink {
    public static notBoughtModules: string[] = [];

    public static disabledModules: string[] = [];

    public static clean(links: ILink[]) {
        this.notBoughtModules = [];
        this.disabledModules = [];
        this.cleanRecursivelyAllLinks(links);
    }

    public static checkModule(modules: string[], module) {
        return modules.includes(module);
    }

    /*
       * This method recursively walks over all links and subLinks
       * and sets the show property to true if its module is within the
       * modules array, if a subLink is set to true its container link has to be set to true
       * */
    // public static setLinkPermissionsRecursive(link: ILink, modules: string[]) {
    //     if (!link.module && !link.modules?.length) {
    //         return;
    //     }
    //     if (link.lockModule && !modules.includes(link.lockModule as string)) {
    //         this.notBoughtModules.push(link.lockModule);
    //     } else {
    //         link.unlock = true;
    //     }
    //     let allPermitted = true;
    //     if (link.modules) {
    //         const condition = modules.reduce(
    //             (acc, module) => acc &&
    //                 !!link.modules?.find((m) => m === module), true);
    //         if (!condition) {
    //             this.disabledModules.push(...link.modules);
    //         } else {
    //             link.show = true;
    //         }
    //
    //     } else {
    //
    //         if (link.module && !modules.includes(link.module as string)) {
    //             this.disabledModules.push(link.module);
    //         } else {
    //             link.show = true;
    //         }
    //     }
    //     if (link.subMenu && link.subMenu.length) {
    //         link.subMenu.forEach((subLink) => {
    //             this.setLinkPermissionsRecursive(subLink, modules);
    //             if (subLink.subMenu?.some((item) => item.show)) {
    //                 link.show = true;
    //             }
    //         });
    //     }
    // }
    public static setLinkPermissionsRecursive(link: ILink, modules: string[]) {
        if (!link.module && !link.modules?.length) return;

        const isModuleIncluded = (module: string) => modules.includes(module);

        if (link.lockModule && !isModuleIncluded(link.lockModule as string)) {
            this.notBoughtModules.push(link.lockModule);
        } else {
            link.unlock = true;
        }

        if (link.modules?.length) {
            const allPermitted = link.modules.every(isModuleIncluded);
            if (!allPermitted) {
                this.disabledModules.push(...link.modules);
            } else {
                link.show = true;
            }
            if (link.subMenu?.length) {
                link.subMenu.forEach((subLink) => {
                    this.setLinkPermissionsRecursive(subLink, modules);
                    if (subLink.show) link.show = true;
                });
            }
        }
    }

    private static cleanRecursivelyAllLinks(links: ILink[]) {
        links.forEach((link) => {
            link.show = false;
            if (link.leaves) {
                this.clean(link.subMenu as ILink[]);
            }
        });
    }
}
